import { Editable } from './editable';
export default Editable;
